import moment from "moment";
import React from "react";
import { formatTime } from "utilities";

interface Props {
  dateTime: server.dto.AppointmentDateTime
}

const ShowTime = (props: Props) => {
  if (props.dateTime.mode === "allDay") {
    if (!props.dateTime.customFallbackTime) return null;

    return <span className="s1_blue s1_small">{props.dateTime.customFallbackTime}</span>;
  }

  const startDisplayMoment = moment.utc(props.dateTime.startDisplay);
  const endDisplayMoment = moment.utc(props.dateTime.endDisplay);

  const isSameMoment = startDisplayMoment.isSame(endDisplayMoment);
  if (isSameMoment) {
    return <span className="s1_small">{formatTime(startDisplayMoment)}</span>;
  }

  const isSameDay = startDisplayMoment.isSame(endDisplayMoment, "day");
  if (isSameDay) {
    return <span className="s1_small">{formatTime(startDisplayMoment)}&nbsp;-&nbsp;{formatTime(endDisplayMoment)}</span>;
  }

  return <span className="s1_small">{formatTime(startDisplayMoment)}&nbsp;-&nbsp;<span className="s1_gray">{formatTime(endDisplayMoment)}</span></span>;
};

export default ShowTime;